import {ApiResponse} from "../models/api-response.model";
import {apiDelete, apiGet, apiPost} from '../utils/api.util';
import {PaginationParams} from "../models/pagination.model";
import {buildPaginatedUrl} from "../utils/api.util";

export interface Bank {
    id?: number;
    name: string;
    shortName: string;
}


export const loadBanks = async (params?: PaginationParams): Promise<ApiResponse<Bank[]>> => {
    const response = await apiGet(buildPaginatedUrl('/api/v1/pm/banks', params));
    return await response.json();
};

export const createBank = async (bank: Bank): Promise<ApiResponse<Bank>> => {
    const response = await apiPost('/api/v1/pm/banks', bank, {});
    return await response.json();
};

export const updateBank = async (bank: Bank): Promise<ApiResponse<Bank>> => {
    const response = await apiPost(`/api/v1/pm/banks/${bank.id}`, bank, {});
    return await response.json();
};

export const deleteBank = async (bankId: number): Promise<ApiResponse<any>> => {
    const response = await apiDelete(`/api/v1/pm/banks/${bankId}`, {});
    return await response.json();
};
